import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { SvgMatType } from "src/app/constants/icons";
import { EnrollmentBenefitCategoryItem } from "src/app/models/enrollment-category";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-benefit-enrollment-time-line', 
    templateUrl: './time-line.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitEnrollmentTimeLineComponent implements OnInit, OnChanges {
    @Input() public benefitCategories: EnrollmentBenefitCategoryItem[];
    @Input() public isCheckoutEnabled: boolean;

    public svgType = SvgMatType;
    public timelineList: EnrollmentBenefitCategoryItem[];
    public sideTimelineList: EnrollmentBenefitCategoryItem[];

    constructor(
        public enrollmentManagerService: EnrollmentManagerService,
    ) {
    }

    ngOnInit(): void {
        this.enrollmentManagerService.$UpdateTimeline.subscribe((id: number) => {
            this.setSideTimeLine();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.timelineList != this.benefitCategories) {
            this.timelineList = this.benefitCategories;
            this.setSideTimeLine();
        }
    }

    public categoryChange(category: EnrollmentBenefitCategoryItem): void {
        this.enrollmentManagerService.$TimelineSelectedCategory.next(category);
    }

    public setSideTimeLine(): void {
        this.sideTimelineList = new Array<EnrollmentBenefitCategoryItem>();
        this.benefitCategories.forEach((bc: EnrollmentBenefitCategoryItem, index: number) => {
            this.sideTimelineList.push(bc);
        });
        this.enrollmentManagerService.checkoutItem.isDisabled = !this.isCheckoutEnabled;
        this.sideTimelineList.push(this.enrollmentManagerService.checkoutItem);
    }
}